import React from "react";

export default function Portfolio() {
  return (
    <>
      <section id="portfolio" className="portfolio section-bg">
        <div className="container">
          <div className="section-title">
            <h2>Portfolio</h2>
            <p></p>
          </div>
          <div className="row" data-aos="fade-up">
            <div className="col-lg-12 d-flex justify-content-center">
              <ul id="portfolio-flters">
                <li data-filter="*" className="filter-active">
                  All
                </li>
                <li data-filter=".filter-digital">
                  Digital Marketing material
                </li>
                <li data-filter=".filter-app">App</li>
                <li data-filter=".filter-card">Card and graphics</li>
                <li data-filter=".filter-web">Web</li>
              </ul>
            </div>
          </div>

          <div
            className="row portfolio-container"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="col-lg-4 col-md-6 portfolio-item filter-web">
              <div className="portfolio-wrap">
                <img
                  src="i_assets/img/portfolio/web-01.webp"
                  className="img-fluid"
                  alt="web-01"
                />
                <div className="portfolio-links">
                  <a
                    href="i_assets/img/portfolio/web-01.webp"
                    data-gall="portfolioGallery"
                    className="venobox"
                    title="web 01"
                  >
                    <i className="bx bx-plus"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item filter-web">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/web-02.webp"
                className="img-fluid"
                alt="web-02"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/web-02.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="web 02"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/web-03.webp"
                className="img-fluid"
                alt="web-03"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/web-03.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="web 03"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/web-04.webp"
                className="img-fluid"
                alt="web-04"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/web-04.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="web 04"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-digital">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/digital-01.webp"
                className="img-fluid"
                alt="digital-01"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/digital-01.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="digital 01"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-digital">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/digital-02.webp"
                className="img-fluid"
                alt="digital-02"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/digital-02.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="digital 02"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-digital">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/digital-03.webp"
                className="img-fluid"
                alt="digital-03"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/digital-03.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="digital 03"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-digital">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/digital-04.webp"
                className="img-fluid"
                alt="digital-04"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/digital-04.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="digital 04"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-digital">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/digital-05.webp"
                className="img-fluid"
                alt="digital-05"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/digital-05.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="digital 05"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-digital">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/digital-06.webp"
                className="img-fluid"
                alt="digital-06"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/digital-06.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="digital 06"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-card">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/g1.webp"
                className="img-fluid"
                alt="g1"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/g1.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="Graphics 1"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-card">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/g2.webp"
                className="img-fluid"
                alt="g2"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/g2.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="Graphics 2"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-card">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/g3.webp"
                className="img-fluid"
                alt="g3"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/g3.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="Graphics 3"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-card">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/g4.webp"
                className="img-fluid"
                alt="g4"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/g4.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="Graphics 4"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-card">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/g5.webp"
                className="img-fluid"
                alt="g5"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/g5.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="Graphics 5"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-card">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/g6.webp"
                className="img-fluid"
                alt="g6"
              />
              <div className="portfolio-links">
                <a
                  href="i_assets/img/portfolio/g6.webp"
                  data-gall="portfolioGallery"
                  className="venobox"
                  title="Graphics 6"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-app">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/app-01.webp"
                className="img-fluid"
                alt="app-01"
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-app">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/app-02.webp"
                className="img-fluid"
                alt="app-02"
              />
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item  filter-app">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/app-03.webp"
                className="img-fluid"
                alt="app-03"
              />
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-app">
            <div className="portfolio-wrap">
              <img
                src="i_assets/img/portfolio/app-04.webp"
                className="img-fluid"
                alt="app-04"
              />
            </div>
          </div>
          </div>
          
        
        </div>
        
      </section>
    </>
  );
}
